import React from 'react';
// import '../Styles/spinner.css';

export default function LoadingSpinner() {
  return <div />;
}
